export default "__VITE_ASSET__52f574e2__"